import React, { Fragment, useEffect, useRef } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoading,
  makeSelectQuestionTypes,
  makeSelectTotalQuestions,
} from "./selectors"
import { getListCountQuestionsWatcher } from "./actions"

import "./index.less"
import { Divider, Spin } from "antd"
import { get } from "lodash"
import { LikertIcon } from "../../../icons/svg/iconLikert"
import { EnpsIcon } from "../../../icons/svg/iconEnps"
import { QualitativeIcon } from "../../../icons/svg/iconQualitative"
import { MultipleChoiceIcon } from "../../../icons/svg/iconMultipleChoice"
import { TYPE_SURVEY } from "../../../utils/constants"
import { loadTexts } from "../../../utils/i18n"

export function SummaryQuestions(props) {
  const intl = loadTexts("reports_general_view")

  const lastParamsRef = useRef({})

  useEffect(() => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props

    const currentParams = {
      id_measure: idMeasure,
      id_division: idDivisionSelected || idDivisionParent,
      id_segment: selectedSegment,
    }

    
    if (
      JSON.stringify(currentParams) !== JSON.stringify(lastParamsRef.current)
    ) {
      lastParamsRef.current = currentParams
      props.getListCountQuestions(currentParams)
    }
  }, [props.idMeasure, props.idDivisionSelected, props.idDivisionParent, props.selectedSegment])

  const renderTypeLikert = () => {
    if (get(props.questionTypes, "likert", 0) === 0) return null
    return (
      <div className="SummaryQuestions-CountType-item">
        <LikertIcon style={{ marginRight: "8px" }} />
        <span style={{ fontWeight: "600" }}>
          {get(props.questionTypes, "likert", 0) +
            intl.reportAmbassador.engagementMeasurement.summaryQuestions.likert}
        </span>
      </div>
    )
  }

  const renderTypeEnps = () => {
    if (get(props.questionTypes, "enps", 0) === 0) return null
    return (
      <div className="SummaryQuestions-CountType-item">
        <EnpsIcon style={{ marginRight: "8px" }} />
        <span style={{ fontWeight: "600" }}>
          {get(props.questionTypes, "enps", 0)}{" "}
          {get(props.measureGeneral, "id_survey_type", TYPE_SURVEY.climate.idSurveyType) !==
          TYPE_SURVEY.climate.idSurveyType
            ? "NPS"
            : "eNPS"}
        </span>
      </div>
    )
  }

  const renderTypeQualitative = () => {
    if (get(props.questionTypes, "qualitative", 0) === 0) return null
    const text =
      get(props.questionTypes, "qualitative", 0) > 1
        ? intl.reportAmbassador.engagementMeasurement.summaryQuestions.qualitatives
        : intl.reportAmbassador.engagementMeasurement.summaryQuestions.qualitative
    return (
      <div className="SummaryQuestions-CountType-item">
        <QualitativeIcon style={{ marginRight: "8px" }} />
        <span style={{ fontWeight: "600" }}>
          {get(props.questionTypes, "qualitative", 0)} {text}
        </span>
      </div>
    )
  }

  const renderTypeMultipleChoice = () => {
    if (get(props.questionTypes, "multipleChoice", 0) === 0) return null
    return (
      <div className="SummaryQuestions-CountType-item">
        <MultipleChoiceIcon style={{ marginRight: "8px" }} />
        <span style={{ fontWeight: "600" }}>
          {get(props.questionTypes, "multipleChoice", 0) +
            intl.reportAmbassador.engagementMeasurement.summaryQuestions
              .multipleChoice}
        </span>
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <Fragment>
        <div className="SummaryQuestions loadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  return (
    <div className="SummaryQuestions">
      <div className="SummaryQuestions-Total">
        {intl.reportAmbassador.engagementMeasurement.summaryQuestions.total +
          get(props, "totalQuestions", 0)}
      </div>
      <Divider type="vertical" style={{ height: "24px" }} />
      <div className="SummaryQuestions-CountType">
        {renderTypeLikert()}
        {renderTypeEnps()}
        {renderTypeQualitative()}
        {renderTypeMultipleChoice()}
      </div>
    </div>
  )
}

SummaryQuestions.propTypes = {
  idMeasure: PropTypes.number,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoading: PropTypes.bool,
  questionTypes: PropTypes.object,
  totalQuestions: PropTypes.number,
  getListCountQuestions: PropTypes.func,
  isLeadership: PropTypes.bool,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  questionTypes: makeSelectQuestionTypes(),
  totalQuestions: makeSelectTotalQuestions(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListCountQuestions: (params) =>
      dispatch(getListCountQuestionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "summaryQuestions", reducer })
const withSaga = injectSaga({ key: "summaryQuestions", saga })

export default compose(withReducer, withSaga, withConnect)(SummaryQuestions)
